import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

Vue.use(Vuex);

export const store = new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    app_version: process.env.VUE_APP_VERSION,
    token: null,
    client_status: false,
    employee: {},
    initialMenu: [],
    menu: [],
    main_menu: [],
    company_menu: [],
    sub_company_menu: [],
    module: [],
    companies: [],
    sub_companies: [],
    infobarStatus: false,
    infobar: {
      type: "",
      text: "",
    },
    loading: false,
    unauthorized: false,
    tempData: null,
    company: {},
    subcompany: {},
    enableNavDrawer: false,
    fareMatrixItems: [],
  },
  getters,
  mutations,
  actions,
});
